/* Landing Made in Italy · Leone Sport · sezione Shopify (tema Horizon)
   Conversione del prototipo v2 in un custom element <mii-landing>.

   - Una scena per scatto (dal 19/10/2026): ogni scena è alta uno schermo, rotella, tasti e dito portano
     alla scena dopo e la sua sequenza va a tempo (TEMPO). Tre cicli requestAnimationFrame, ognuno attivo solo
     quando serve: scroll (barra e misure), passaggio tra due scene, sequenza della scena corrente.
   - Le scene stanno sotto la testata del tema: --mii-top = altezza della testata agganciata.
     Il progresso di una scena usa l'altezza dello stage (100svh meno la testata), non 100vh.
   - Su desktop Horizon fa scorrere .page-wrapper, non la finestra: il contenitore che scorre
     si cerca a ogni misura (cambia sopra e sotto i 990 px).
   - Movimento ridotto (anche cambiato a pagina aperta), schermo più basso di 360 px (anche per zoom)
     o ?statico nell'URL: pagina statica leggibile.
   - Se qualcosa sopra la landing cambia altezza senza un resize (editor, banner di un'app) si rimisura.
   - Un pulsante ferma e riprende tutti i video (WCAG 2.2.2), di tutte le parti della landing.
   - Editor del tema: la sezione viene ridisegnata senza ricaricare la pagina, quindi tutto parte
     in connectedCallback e si smonta in disconnectedCallback (rAF, osservatori, listener);
     se cambia un'altra sezione (eventi shopify:section:*) le parti rimaste rimisurano.
   - Clic su una voce della barra: la pagina salta alla scena e il fuoco va lì (il Tab riparte dalla scena).
   - Landing in due parti (data-parte="prima" / "seconda", con il carosello del tema in mezzo):
     ogni istanza anima solo le sue scene, con il suo ciclo; nessuna scena è obbligatoria.
     Le voci della barra cercano le scene per id nel documento (anche nell'altra istanza);
     "La linea" delle due parti porta alla sezione del tema con il carosello prodotti.
   - Il file arriva una volta per istanza: il secondo caricamento esce subito (definizione già fatta). */
(function () {
  'use strict';

  if (!window.customElements || window.customElements.get('mii-landing')) return;

  /* Stato condiviso da tutte le istanze: il pulsante dei video ferma e riprende l'intera landing */
  var STATO = { fermo: false };

  var PICCOLO = 760;                      // px, stesso limite del CSS (telefono)
  var VICINO = '200% 0px 200% 0px';       // "entro 2 schermate": immagini, anteprime, fotogrammi
  /* Una scena per scatto (scelta di Alex del 19/10/2026, ritmo medio): ogni scena è alta uno schermo;
     uno scatto di rotella, un tasto o un colpo di dito porta alla scena dopo, la pagina si aggancia e la
     sequenza della scena va da sola, a tempo. Scorrendo prima della fine si passa alla scena dopo;
     tornando su la scena è già completa. Fuori dalle scene (carosello del tema, fondo pagina) lo scroll è normale. */
  var TEMPO = {                            // secondi di ogni sequenza; 0 = scena ferma
    hero: 0, fine: 0, tuffo: 4.6, manifesto: 2.5, capitolo: 7.2,
    dettagli: 6.5, mosaico: 6, linea: 8, storia: 6, passi: 6
  };
  var SCATTO = 750;                        // ms del passaggio da una scena all'altra
  var QUIETE = 160;                        // ms senza rotella: il gesto è finito (filtra l'inerzia del touchpad)
  var DOPO = 650;                          // ms dopo un passaggio in cui un gesto ancora in corso non conta
  /* Tre frasi del tuffo: entrata e uscita in secondi */
  var FASCE = [[.15, 1.25], [1.1, 2.2], [2.05, 3.15]];
  /* Clip dei capitoli una alla volta (variante C del 15/10): y in centesimi di stage per entrata, sosta e uscita */
  var CLIP_Y = { desktop: [64, 34, 28, 4], telefono: [86, 58, 52, 40] };
  var VEL = [1, .72, 1.18, .88];          // velocità delle colonne del muro
  var BASSO = 360;                        // px: sotto questa altezza dello schermo le scene non ci stanno (zoom, telefono girato)
  /* eventi dell'editor del tema quando una sezione si aggiunge, si toglie o si nasconde, si ridisegna o si sposta */
  var SEZIONI = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'];

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function range(p, a, b) { return clamp((p - a) / (b - a), 0, 1); }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }
  function easeIO(t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function tutti(sel, el) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function visibile(el) { return el.getClientRects().length > 0; }
  function gioca(v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
  function statico(mq) { return mq.matches || window.innerHeight < BASSO || /[?&]statico(&|=|$)/.test(location.search); }

  /* Il contenitore che scorre: il primo antenato con overflow-y diverso da visible e clip (stessa regola dello sticky)
     che ha contenuto da scorrere, altrimenti la finestra. Vale anche con overflow hidden: Horizon mette
     html[scroll-lock] .page-wrapper { overflow: hidden } quando apre carrello, ricerca o menu, ma resta lui a scorrere. */
  function trovaScroller(el) {
    for (var n = el.parentElement; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      var oy = getComputedStyle(n).overflowY;
      if (oy !== 'visible' && oy !== 'clip' && n.scrollHeight > n.clientHeight + 1) return n;
    }
    return window;
  }

  /* La sezione del tema con il carosello prodotti accanto alla landing divisa in due parti.
     Prima parte: si cerca in avanti, poi indietro; seconda parte: il contrario. Ci si ferma a un'altra
     parte della landing. Si cerca la sezione che contiene [data-testid="product-list"] (ln-product-list
     e product-list di Horizon); se non c'è, la sezione subito dopo (prima parte) o subito prima (seconda). */
  function trovaVetrina(radice, parte) {
    var sez = radice.closest ? radice.closest('.shopify-section') : null;
    if (!sez) return null;
    var dirs = parte === 'seconda' ? ['previousElementSibling', 'nextElementSibling'] : ['nextElementSibling', 'previousElementSibling'];
    function sezione(n) { return n.classList && n.classList.contains('shopify-section') && !n.querySelector('mii-landing'); }
    for (var i = 0; i < dirs.length; i++) {
      for (var n = sez[dirs[i]]; n && !n.querySelector('mii-landing'); n = n[dirs[i]]) {
        if (sezione(n) && n.querySelector('[data-testid="product-list"]')) return n;
      }
    }
    var r = sez[dirs[0]];
    return r && sezione(r) ? r : null;
  }

  /* Altezza della testata quando è agganciata in alto (top dello sticky + altezza); 0 se la testata non è sticky */
  function altezzaTestata() {
    var cand = ['header-component', '#header-group', '[id*="header_section"]'], h = null, r = null;
    for (var i = 0; i < cand.length && !h; i++) {
      var el = document.querySelector(cand[i]);
      if (el) { r = el.getBoundingClientRect(); if (r.height) h = el; }
    }
    if (!h) return 0;
    for (var n = h; n && n !== document.body; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        return Math.max(0, Math.round((parseFloat(cs.top) || 0) + r.height));
      }
    }
    return 0;
  }

  /* ---- Scene: t sono i secondi dall'inizio della sequenza, p = t / TEMPO (0-1),
     L è l'istanza (u = 1/100 dello stage, in px). Con t = 0 la scena è all'inizio, con t = TEMPO è completa. ---- */
  var H = {
    hero: function () {},
    fine: function () {},

    /* Tuffo: fotogrammi e tre frasi in circa 3 secondi, poi l'Orlando con prezzo e pulsante */
    tuffo: function (s, t, p, L) {
      L.caricaFotogrammi();                       // di solito è già partito con l'osservatore "vicino"
      var v = range(t, 0, 2.9), tf = L.tf;
      if (tf && tf.urls.length) L.disegna(Math.round(v * (tf.urls.length - 1)));
      if (s.film) {
        s.film.style.transform = 'scale(' + (1.04 + .32 * ease(v)).toFixed(4) + ')';
        s.film.style.opacity = String(1 - .82 * ease(range(t, 2.8, 3.4)));
      }
      s.fasce.forEach(function (f, i) {
        var w = FASCE[Math.min(i, FASCE.length - 1)], q = range(t, w[0], w[1]), o = q < .3 ? q / .3 : q > .7 ? (1 - q) / .3 : 1;
        f.el.style.opacity = String(o);
        f.el.style.filter = 'blur(' + ((1 - o) * 10).toFixed(1) + 'px)';
        f.el.style.transform = 'translateY(calc(-50% + ' + ((.5 - q) * 8 * L.u).toFixed(1) + 'px)) scale(' + (.96 + q * .08).toFixed(3) + ')';
      });
      var g = ease(range(t, 3, 3.9));
      if (s.alone) s.alone.style.opacity = String(g);
      if (s.guanti) {
        s.guanti.style.opacity = String(range(t, 3, 3.3));
        s.guanti.style.transform = 'translate(-50%,' + (lerp(70, 0, g) * L.u).toFixed(1) + 'px) rotate(' + lerp(-12, 0, g).toFixed(2) + 'deg) scale(' + lerp(.86, 1, g).toFixed(3) + ')';
      }
      var c = ease(range(t, 3.6, 4.5));
      if (s.scheda) {
        s.scheda.style.opacity = String(c);
        s.scheda.style.transform = 'translateY(' + lerp(30, 0, c).toFixed(1) + 'px)';
      }
      if (s.rivela) s.rivela.classList.toggle('mii-attiva', c > .5);
    },

    /* Manifesto: le parole si accendono una dopo l'altra in poco più di 2 secondi */
    manifesto: function (s, t, p, L) {
      var w = L.parole, n = w.length, k = Math.round(range(t, .1, 2.3) * n);
      if (k === s.ultimo) return;
      s.ultimo = k;
      for (var i = 0; i < n; i++) w[i].classList.toggle('mii-on', i < k);
    },

    /* Capitolo: zoom lento nella foto, il testo entra, le clip una alla volta nello stesso punto
       (entra dal basso in dissolvenza, si ferma mentre gira, esce in alto); l'ultima resta.
       Sul telefono le clip restano sotto il testo. */
    capitolo: function (s, t, p, L) {
      if (s.foto) s.foto.style.transform = 'scale(' + (1.04 + .4 * ease(p)).toFixed(4) + ')';
      if (s.testo) {
        s.testo.style.opacity = String(range(t, 0, .6));
        s.testo.style.transform = 'translateY(' + ((1 - ease(range(t, 0, .8))) * 4 * L.u).toFixed(1) + 'px)';
      }
      var Y = L.mobile ? CLIP_Y.telefono : CLIP_Y.desktop, ultima = s.card.length - 1;
      s.card.forEach(function (cd, k) {
        var a = .6 + cd.i * 2.1, q = range(t, a, a + 2.4), y, o;
        if (k === ultima) q = Math.min(q, .69);
        if (q <= 0) { y = Y[0]; o = 0; }
        else if (q < .3) { var e = ease(q / .3); y = lerp(Y[0], Y[1], e); o = e; }
        else if (q < .7) { y = lerp(Y[1], Y[2], (q - .3) / .4); o = 1; }
        else { var f = (q - .7) / .3; y = lerp(Y[2], Y[3], f * f); o = 1 - f; }
        cd.el.style.transform = 'translateY(' + (y * L.u).toFixed(1) + 'px)';
        cd.el.style.opacity = o.toFixed(3);
      });
    },

    dettagli: function (s, t, p) {
      var n = s.voci.length;
      if (!n) return;
      var idx = Math.min(n - 1, Math.floor(range(p, .03, .97) * n));
      if (idx === s.ultimo) return;
      s.ultimo = idx;
      s.foto.forEach(function (im, i) { im.classList.toggle('mii-on', i === idx); });
      s.voci.forEach(function (li, i) { li.classList.toggle('mii-on', i === idx); });
    },

    mosaico: function (s, t, p, L) {
      s.col.forEach(function (c, i) {
        var corsa = Math.max(0, (s.alt[i] || 0) - L.sh);
        var y = i % 2 ? -corsa * (1 - p) : -corsa * p;
        c.style.transform = 'translateY(' + y.toFixed(1) + 'px)';
      });
      var n = s.parole.length;
      if (!n || !s.parola) return;
      var w = Math.min(n - 1, Math.floor(range(p, .02, .98) * n));
      if (w !== s.ultimo) { s.ultimo = w; s.parola.textContent = s.parole[w]; }
    },

    linea: function (s, t, p, L) {
      var v = s.voci, n = v.length;
      if (!n) return;
      var f = range(p, .04, .96) * (n - 1);
      var R = L.mobile ? L.sw * 1.05 : Math.max(L.sh * .95, 640), passo = L.mobile ? .5 : .42;
      var cx = L.sw / 2, cy = L.sh * (L.mobile ? .47 : .5) + R;
      v.forEach(function (el, i) {
        var a = (i - f) * passo, d = Math.abs(a);
        if (d > 1.7) { el.style.opacity = '0'; return; }
        var x = cx + R * Math.sin(a), y = cy - R * Math.cos(a);
        var sc = lerp(1, .55, Math.min(1, d / 1.1));
        el.style.opacity = String(1 - Math.min(1, d / 1.5) * .85);
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) translate(-50%,-50%) rotate(' + (a * 34).toFixed(2) + 'deg) scale(' + sc.toFixed(3) + ')';
        el.style.zIndex = String(100 - Math.round(d * 20));
      });
      var att = Math.round(f);
      if (att !== s.ultimo) {
        s.ultimo = att;
        var dati = v[att].dataset;
        if (s.tipoEl) s.tipoEl.textContent = dati.tipo || '';
        if (s.nome) s.nome.textContent = dati.nome || '';
        if (s.prezzo) s.prezzo.textContent = dati.prezzo || '';
        if (s.link) s.link.setAttribute('href', dati.url || '#');
        /* lettori di schermo: un testo unico, scritto solo se cambia (niente annunci ripetuti a ogni misura) */
        var testo = [dati.tipo, dati.nome, dati.prezzo].filter(Boolean).join(', ');
        if (s.annuncio && s.annuncio.textContent !== testo) s.annuncio.textContent = testo;
      }
    },

    storia: function (s, t, p, L) {
      s.col.forEach(function (c, i) {
        var corsa = Math.max(0, (s.alt[i] || 0) - L.sh) + L.sh * .5;
        c.style.transform = 'translateY(' + (L.sh * .25 - corsa * p * VEL[i % 4]).toFixed(1) + 'px)';
      });
    },

    passi: function (s, t, p) {
      var n = s.passi.length;
      if (!n) return;
      var f = clamp(p * n, 0, n - .0001), idx = Math.floor(f);
      for (var i = 0; i < s.barre.length; i++) s.barre[i].style.transform = 'scaleX(' + clamp(f - i, 0, 1).toFixed(3) + ')';
      if (idx === s.ultimo) return;
      s.ultimo = idx;
      s.passi.forEach(function (el, i) { el.classList.toggle('mii-attivo', i === idx); });
    }
  };

  class MiiLanding extends HTMLElement {
    constructor() {
      super();
      this._montato = false;
      this._attendi = null;
      this._tick = this.tick.bind(this);
      this._onScroll = this.programma.bind(this);
      this._onResize = this.misura.bind(this);
      this._onModo = this.applicaModo.bind(this);
      this._onClick = this.alClick.bind(this);
      this._onFocus = this.alFocus.bind(this);
      this._onBlocco = this.alBlocco.bind(this);
      this._onSezioni = this.dopoSezioni.bind(this);
      this._tSezioni = 0;
      this._onRotella = this.alRotella.bind(this);
      this._onTasto = this.alTasto.bind(this);
      this._onToccoInizio = this.alToccoInizio.bind(this);
      this._onToccoMuove = this.alToccoMuove.bind(this);
      this._onToccoFine = this.alToccoFine.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        var self = this;
        this._attendi = function () { self._attendi = null; if (self.isConnected) self.monta(); };
        document.addEventListener('DOMContentLoaded', this._attendi);
        return;
      }
      this.monta();
    }

    disconnectedCallback() {
      if (this._attendi) { document.removeEventListener('DOMContentLoaded', this._attendi); this._attendi = null; }
      this.smonta();
    }

    /* ---- Avvio e pulizia ---- */
    monta() {
      if (this._montato) return;
      this._montato = true;
      this.mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.raf = 0;
      this.ultimoY = -1;
      this.corrente = -1;                       // pagina (scena) su cui la landing è agganciata
      this.rafSeq = 0;                          // ciclo della sequenza a tempo
      this.rafScatto = 0;                       // ciclo del passaggio tra due scene
      this.inCorsa = false;
      this.fineScatto = -1e9;
      this.ultimoGesto = -1e9;
      this.tocco = null;
      this._tFermo = 0;
      this.fx = false;
      this.scroller = window;
      this.topH = 0;
      this.vista = window.innerHeight;
      this.sh = window.innerHeight;
      this.sw = window.innerWidth;
      this.u = this.sh / 100;
      this.mobile = window.innerWidth <= PICCOLO;
      this.radice = { top: 0, h: 0 };
      this.navH = 0;
      this.vocAtt = null;
      this.fermo = STATO.fermo;                 // video fermati dal pulsante (stato comune alle parti)
      this.classList.toggle('mii-fermo', this.fermo);

      this.dividiManifesto();
      this.raccogli();
      if (this.fermo) this.etichettePausa();

      document.addEventListener('scroll', this._onScroll, { capture: true, passive: true });
      window.addEventListener('resize', this._onResize);
      window.addEventListener('load', this._onResize);
      if (this.mq.addEventListener) this.mq.addEventListener('change', this._onModo);
      else if (this.mq.addListener) this.mq.addListener(this._onModo);
      this.addEventListener('click', this._onClick);
      this.addEventListener('focusin', this._onFocus);
      document.addEventListener('shopify:block:select', this._onBlocco);
      SEZIONI.forEach(function (t) { document.addEventListener(t, this._onSezioni); }, this);
      /* Una scena per scatto: rotella, tasti e dito (non passivi, per poter fermare lo scroll normale) */
      document.addEventListener('wheel', this._onRotella, { passive: false });
      document.addEventListener('keydown', this._onTasto);
      document.addEventListener('touchstart', this._onToccoInizio, { passive: true });
      document.addEventListener('touchmove', this._onToccoMuove, { passive: false });
      document.addEventListener('touchend', this._onToccoFine, { passive: true });

      /* Nell'editor la sezione arriva con un <link> nuovo che si carica dopo: si rimisura a foglio caricato */
      var sez = this.parentNode;
      this._foglio = sez && sez.querySelector ? sez.querySelector('link[rel="stylesheet"][href*="mii-landing"]') : null;
      if (this._foglio && !this._foglio.sheet) this._foglio.addEventListener('load', this._onResize);
      else this._foglio = null;

      this.applicaModo();

      var self = this;
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (self._montato) self.misura(); });

      /* Montato: lo script in linea della sezione non riporta la pagina alla versione statica al load */
      this.setAttribute('data-mii-vivo', '');
    }

    smonta() {
      if (!this._montato) return;
      this._montato = false;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = 0;
      document.removeEventListener('scroll', this._onScroll, { capture: true });
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('load', this._onResize);
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this._onModo);
      else if (this.mq.removeListener) this.mq.removeListener(this._onModo);
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('focusin', this._onFocus);
      document.removeEventListener('shopify:block:select', this._onBlocco);
      SEZIONI.forEach(function (t) { document.removeEventListener(t, this._onSezioni); }, this);
      document.removeEventListener('wheel', this._onRotella, { passive: false });
      document.removeEventListener('keydown', this._onTasto);
      document.removeEventListener('touchstart', this._onToccoInizio, { passive: true });
      document.removeEventListener('touchmove', this._onToccoMuove, { passive: false });
      document.removeEventListener('touchend', this._onToccoFine, { passive: true });
      this.fermaSequenza();
      if (this.rafScatto) cancelAnimationFrame(this.rafScatto);
      this.rafScatto = 0;
      this.inCorsa = false;
      clearTimeout(this._tFermo);
      this._tFermo = 0;
      clearTimeout(this._tSezioni);
      this._tSezioni = 0;
      if (this._foglio) { this._foglio.removeEventListener('load', this._onResize); this._foglio = null; }
      this.chiudiOsservatori();
      if (this.tf) this.tf.annullato = true;     // ferma il caricamento dei fotogrammi
      tutti('video', this).forEach(function (v) { v.pause(); });
      this.removeAttribute('data-mii-vivo');
    }

    /* Manifesto: una parola per volta (una sola divisione, anche se l'elemento viene rimontato) */
    dividiManifesto() {
      var frase = this.querySelector('.mii-manifesto-frase');
      this.parole = [];
      if (!frase) return;
      if (!frase.hasAttribute('data-mii-diviso')) {
        frase.setAttribute('data-mii-diviso', '');
        (function dividi(el) {
          Array.prototype.slice.call(el.childNodes).forEach(function (n) {
            if (n.nodeType === 3) {
              var frag = document.createDocumentFragment();
              n.textContent.split(/(\s+)/).forEach(function (w) {
                if (!w) return;
                if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
                var sp = document.createElement('span');
                sp.className = 'mii-p';
                sp.textContent = w;
                frag.appendChild(sp);
              });
              n.parentNode.replaceChild(frag, n);
            } else if (n.nodeType === 1) {
              dividi(n);
            }
          });
        })(frase);
      }
      this.parole = tutti('.mii-p', frase);
    }

    /* Riferimenti agli elementi di ogni scena (il markup arriva dal Liquid). Nessuna scena è obbligatoria:
       una parte della landing ha solo le sue. */
    raccogli() {
      var self = this;
      this.parte = this.getAttribute('data-parte') || 'tutta';
      this.tf = null;
      this.nav = this.querySelector('.mii-barra');
      this.logo = this.nav ? this.nav.querySelector('.mii-barra-logo') : null;
      /* Voci della barra: la scena si cerca per id nel documento (può stare nell'altra parte);
         "La linea" delle due parti (data-mii-vetrina) porta alla sezione del carosello del tema */
      this.voci = this.nav ? tutti('.mii-barra-voci a', this.nav).map(function (a) {
        var h = a.getAttribute('href') || '';
        return { a: a, id: h.charAt(0) === '#' ? h.slice(1) : '', vetrina: a.hasAttribute('data-mii-vetrina'), el: null };
      }) : [];

      this.scene = tutti('[data-scene]', this).map(function (el) {
        var s = { el: el, tipo: el.getAttribute('data-scene'), top: 0, h: 0, ultimo: -1 };
        var q = function (sel) { return el.querySelector(sel); };
        var qq = function (sel) { return tutti(sel, el); };
        switch (s.tipo) {
          case 'hero':
            s.media = q('.mii-hero-media'); s.testa = q('.mii-hero-testa'); s.scorri = q('.mii-scorri');
            break;
          case 'tuffo':
            s.film = q('.mii-tuffo-film'); s.rivela = q('.mii-rivela'); s.guanti = q('.mii-rivela-guanti');
            s.alone = q('.mii-alone'); s.scheda = q('.mii-rivela-scheda');
            s.fasce = qq('.mii-fascia').map(function (f) {
              return { el: f, da: parseFloat(f.getAttribute('data-da')) || 0, a: parseFloat(f.getAttribute('data-a')) || 1 };
            });
            self.preparaTuffo(s);
            break;
          case 'capitolo':
            s.foto = q('.mii-cap-foto'); s.testo = q('.mii-cap-testo');
            s.card = qq('.mii-clip-card').map(function (c) {
              return { el: c, i: c.classList.contains('mii-c3') ? 2 : c.classList.contains('mii-c2') ? 1 : 0 };
            });
            break;
          case 'dettagli':
            s.foto = qq('.mii-det-foto > *'); s.voci = qq('.mii-det-lista > li');
            break;
          case 'mosaico':
            s.col = qq('.mii-mos-col'); s.parola = q('.mii-mos-parola');
            s.parole = ((s.parola && s.parola.getAttribute('data-parole')) || '').split(',')
              .map(function (t) { return t.trim(); }).filter(Boolean);
            break;
          case 'linea':
            s.voci = qq('.mii-arco-v'); s.tipoEl = q('.mii-arco-tipo'); s.nome = q('.mii-arco-nome');
            s.prezzo = q('.mii-arco-prezzo'); s.link = q('.mii-arco-link'); s.annuncio = q('.mii-arco-annuncio');
            break;
          case 'storia':
            s.col = qq('.mii-muro-col');
            break;
          case 'passi':
            s.passi = qq('.mii-passo'); s.barre = qq('.mii-passi-righe b');
            break;
        }
        return s;
      }).filter(function (s) { return H[s.tipo]; });

      this.perTipo = {};
      this.scene.forEach(function (s) { if (!self.perTipo[s.tipo]) self.perTipo[s.tipo] = s; });
      this.video = tutti('video[data-src]', this);
      this.vicini = tutti('[data-scene], .mii-fine', this);

      /* Pagine della "scena per scatto": le scene e la chiusura, nell'ordine della pagina */
      var fine = this.querySelector('.mii-fine');
      this.pagine = this.scene.slice();
      if (fine) this.pagine.push({ el: fine, tipo: 'fine', top: 0, h: 0, ultimo: -1 });
    }

    /* ---- Modo: scene guidate dallo scroll o pagina statica ---- */
    applicaModo() {
      if (!this._montato) return;
      this.fx = !statico(this.mq);
      this.classList.toggle('mii-fx', this.fx);
      if (this.fx) this.agganciaPoster();
      else this.pulisci();
      this.misura();
      this.osservatori();
    }

    /* Versione statica: via gli stili messi dallo scroll (restano le variabili --i, --fuoco, --mii-top) */
    pulisci() {
      this.fermaSequenza();
      if (this.rafScatto) cancelAnimationFrame(this.rafScatto);
      this.rafScatto = 0;
      this.inCorsa = false;
      this.corrente = -1;
      tutti('[style]', this).forEach(function (el) {
        el.style.removeProperty('transform');
        el.style.removeProperty('opacity');
        el.style.removeProperty('filter');
        el.style.removeProperty('z-index');
      });
      tutti('.mii-attiva', this).forEach(function (el) { el.classList.remove('mii-attiva'); });
      tutti('video', this).forEach(function (v) { v.pause(); });
    }

    /* ---- Misure ---- */
    y() {
      return this.scroller === window ? (window.pageYOffset || document.documentElement.scrollTop || 0) : this.scroller.scrollTop;
    }

    /* Posizione di un elemento nel contenuto che scorre */
    posizione(el, y, base) {
      return el.getBoundingClientRect().top - base + y;
    }

    misura() {
      if (!this._montato) return;
      /* lo schermo è diventato troppo basso (o è tornato alto): cambia modo, applicaModo rimisura */
      if (this.fx === statico(this.mq)) { this.applicaModo(); return; }
      var vecchio = this.scroller;
      this.scroller = trovaScroller(this);
      if (this.scroller !== vecchio && this.ioVideo) this.osservatori();

      this.topH = altezzaTestata();
      this.style.setProperty('--mii-top', this.topH + 'px');
      this.mobile = window.innerWidth <= PICCOLO;
      this.vista = this.scroller === window ? window.innerHeight : this.scroller.clientHeight;

      var stage = this.querySelector('.mii-scene > .mii-stage');
      this.sh = this.fx && stage && stage.clientHeight ? stage.clientHeight : Math.max(1, this.vista - this.topH);
      this.sw = stage && stage.clientWidth ? stage.clientWidth : window.innerWidth;
      this.u = this.sh / 100;
      this.navH = this.nav ? this.nav.offsetHeight : 0;

      var y = this.y(), base = this.baseScroller(), self = this;
      this.radice = { top: this.posizione(this, y, base), h: this.offsetHeight };
      this.pagine.forEach(function (s) {
        s.top = self.posizione(s.el, y, base);
        s.h = s.el.offsetHeight;
        s.ultimo = -1;
        if (s.col) s.alt = s.col.map(function (c) { return c.offsetHeight; });
      });
      this.risolviVoci();

      this.dimensionaCanvas();
      this.ultimoY = -1;
      this.allinea(true);
      this.programma();
    }

    /* ---- Ciclo dello scroll: barra e controllo delle misure, solo se lo scroll è cambiato ---- */
    programma() {
      if (!this.raf && this._montato) this.raf = requestAnimationFrame(this._tick);
    }

    tick() {
      this.raf = 0;
      if (!this._montato) return;
      var y = this.y();
      /* qualcosa sopra la landing ha cambiato altezza senza un resize (testata ridisegnata nell'editor,
         banner di un'app): le posizioni misurate non valgono più, si rimisura (misura chiede il fotogramma dopo) */
      if (Math.abs(this.posizione(this, y, this.baseScroller()) - this.radice.top) > 1) { this.misura(); return; }
      if (y === this.ultimoY) return;
      this.ultimoY = y;
      this.barra(y);
      /* Scroll arrivato senza uno scatto (barra di scorrimento, voce della barra, tasti Home e Fine):
         a scroll fermo la scena allineata parte, quelle sopra sono complete, quelle sotto all'inizio */
      if (this.fx && !this.inCorsa) {
        var self = this;
        clearTimeout(this._tFermo);
        this._tFermo = setTimeout(function () { self._tFermo = 0; self.allinea(false); }, 200);
      }
    }

    /* ---- Una scena per scatto ---- */
    /* Disegna la pagina i al secondo t della sua sequenza (t oltre la durata = scena completa) */
    rendi(i, t) {
      var s = this.pagine[i];
      if (!s || !this.fx) return;
      var d = TEMPO[s.tipo] || 0;
      t = clamp(t, 0, d);
      try { H[s.tipo](s, t, d ? t / d : 1, this); } catch (e) { if (window.console) console.error(e); }
    }

    fermaSequenza() {
      if (this.rafSeq) cancelAnimationFrame(this.rafSeq);
      this.rafSeq = 0;
    }

    /* La sequenza della pagina i parte da capo e va a tempo, poi si ferma sulla scena completa */
    avvia(i) {
      this.fermaSequenza();
      this.corrente = i;
      var s = this.pagine[i];
      if (!s) return;
      if (s.tipo === 'tuffo') this.caricaFotogrammi();
      var d = TEMPO[s.tipo] || 0, t0 = performance.now(), self = this;
      if (!d) { this.rendi(i, 0); return; }
      (function passo(ora) {
        if (!self._montato) return;
        var t = Math.max(0, (ora - t0) / 1000);
        self.rendi(i, t);
        self.rafSeq = t < d ? requestAnimationFrame(passo) : 0;
      })(t0);
    }

    /* Posizione di scroll a cui la pagina i è agganciata (inizio della pagina sotto la testata) */
    aggancio(i) { return this.pagine[i].top - this.topH; }

    /* Stato di tutte le pagine secondo lo scroll: quella allineata parte (o resta com'è se è già lei),
       quelle sopra complete, quelle sotto all'inizio. inizio = dopo una misura: niente sequenza nuova. */
    allinea(inizio) {
      if (!this._montato || !this.fx || this.inCorsa) return;
      var y = this.y(), self = this;
      this.pagine.forEach(function (s, i) {
        var a = self.aggancio(i);
        if (Math.abs(a - y) < 4) {
          if (i === self.corrente) return;
          if (inizio) { self.corrente = i; self.rendi(i, Infinity); } else self.avvia(i);
        } else if (i !== self.corrente || inizio) {
          self.rendi(i, a < y ? Infinity : 0);
        }
      });
    }

    /* Dove porta un gesto verso dir (1 giù, -1 su); null = qui non si gestisce, scroll normale.
       Si gestisce da una schermata prima della prima pagina fino all'ultima (in giù) e
       dall'ultima pagina più una schermata fino alla prima (in su). */
    destinazione(dir) {
      var n = this.pagine.length;
      if (!this.fx || !n) return null;
      var y = this.y(), a = this.aggancio(0), b = this.aggancio(n - 1), v = this.sh, i;
      if (dir > 0) {
        if (y < a - v - 1 || y >= b - 1) return null;
        for (i = 0; i < n; i++) {
          var ai = this.aggancio(i);
          /* una scena ferma (l'hero) quasi tutta già in vista non costa uno scatto: si va alla successiva */
          if (ai > y + 2 && !(i < n - 1 && !TEMPO[this.pagine[i].tipo] && ai - y < v * .25)) return i;
        }
      } else {
        if (y <= a + 1 || y > b + v + 1) return null;
        for (i = n - 1; i >= 0; i--) if (this.aggancio(i) < y - 2) return i;
      }
      return null;
    }

    /* Un gesto conta una volta: durante il passaggio e finché la rotella non si ferma (inerzia del touchpad)
       gli eventi si fermano ma non spostano di nuovo */
    gesto(dir, e) {
      var i = this.destinazione(dir);
      if (i === null) return;
      if (e && e.cancelable) e.preventDefault();
      var ora = performance.now(), quieto = ora - this.ultimoGesto > QUIETE;
      this.ultimoGesto = ora;
      if (this.inCorsa) return;
      if (!quieto && ora - this.fineScatto < DOPO) return;
      this.scatto(i, dir);
    }

    /* Passaggio alla pagina i: in giù la scena arriva dall'inizio e la sequenza parte all'aggancio,
       in su arriva già completa */
    scatto(i, dir) {
      this.fermaSequenza();
      this.rendi(i, dir > 0 ? 0 : Infinity);
      if (this.pagine[i].tipo === 'tuffo') this.caricaFotogrammi();
      this.inCorsa = true;
      clearTimeout(this._tFermo);
      var self = this, da = this.y(), a = this.aggancio(i), t0 = performance.now();
      if (this.rafScatto) cancelAnimationFrame(this.rafScatto);
      (function passo(ora) {
        if (!self._montato) return;
        var k = clamp((ora - t0) / SCATTO, 0, 1);
        self.scorriA(da + (a - da) * easeIO(k), 'instant');
        if (k < 1) { self.rafScatto = requestAnimationFrame(passo); return; }
        self.rafScatto = 0;
        self.inCorsa = false;
        self.fineScatto = performance.now();
        if (dir > 0) self.avvia(i); else self.corrente = i;
      })(t0);
    }

    /* Carrello, menu, ricerca o una finestra aperti: la rotella è loro */
    occupato(t) {
      if (document.documentElement.hasAttribute('scroll-lock')) return true;
      return !!(t && t.closest && t.closest('dialog, [role="dialog"], [aria-modal="true"]'));
    }

    alRotella(e) {
      if (!this.fx || e.ctrlKey || Math.abs(e.deltaX) > Math.abs(e.deltaY) || this.occupato(e.target)) return;
      var dir = e.deltaY > 0 ? 1 : e.deltaY < 0 ? -1 : 0;
      if (dir) this.gesto(dir, e);
    }

    /* Freccia giù, Pagina giù e Spazio portano avanti; freccia su, Pagina su e Maiusc+Spazio indietro */
    alTasto(e) {
      if (!this.fx || e.defaultPrevented || e.altKey || e.ctrlKey || e.metaKey || this.occupato(e.target)) return;
      var t = e.target, k = e.key;
      if (t && t.closest && t.closest('input, textarea, select, [contenteditable]')) return;
      if (k === ' ' && t && t.closest && t.closest('a, button, summary')) return;
      if (k === 'ArrowDown' || k === 'PageDown' || (k === ' ' && !e.shiftKey)) this.gesto(1, e);
      else if (k === 'ArrowUp' || k === 'PageUp' || (k === ' ' && e.shiftKey)) this.gesto(-1, e);
    }

    /* Dito: lo scroll normale si ferma dentro la landing, a dito alzato un colpo di almeno 30 px sposta di una scena */
    alToccoInizio(e) { this.tocco = e.touches && e.touches.length === 1 ? e.touches[0].clientY : null; }

    alToccoMuove(e) {
      if (this.tocco === null || !this.fx || this.occupato(e.target)) return;
      var dy = this.tocco - e.touches[0].clientY;
      if (Math.abs(dy) > 4 && this.destinazione(dy > 0 ? 1 : -1) !== null && e.cancelable) e.preventDefault();
    }

    alToccoFine(e) {
      if (this.tocco === null) return;
      var dy = this.tocco - e.changedTouches[0].clientY;
      this.tocco = null;
      if (Math.abs(dy) > 30 && !this.occupato(e.target)) this.gesto(dy > 0 ? 1 : -1, null);
    }

    /* ---- Voci della barra: la scena di ogni voce, anche nell'altra parte della landing ---- */
    bersaglio(v) {
      if (v.el && v.el.isConnected) return v.el;
      v.el = v.vetrina ? trovaVetrina(this, this.parte) : (v.id ? document.getElementById(v.id) : null);
      return v.el;
    }

    /* A ogni misura si ricercano (l'editor può aver ridisegnato o spostato le sezioni). Una voce senza scena
       nella pagina si nasconde; quella del carosello prende l'id vero della sezione del tema. */
    risolviVoci() {
      var self = this;
      this.voci.forEach(function (v) {
        v.el = null;
        var el = self.bersaglio(v);
        v.a.hidden = !el;
        if (v.vetrina && el && el.id) v.a.setAttribute('href', '#' + el.id);
      });
    }

    /* Clic su una voce o sul logo: si scorre il contenitore giusto (finestra o .page-wrapper di Horizon)
       fino all'inizio della scena, sotto la testata. Salto immediato, come gli altri scroll della landing:
       lo scroll animato attraverserebbe le scene caricando fotogrammi e clip. */
    vaiA(el) {
      if (!el) return;
      /* Il fuoco passa alla destinazione, senza scorrere, come con un'ancora: il Tab successivo riparte da lì
         e non dalla barra, che dopo il salto può essere sparita (WCAG 2.4.3). tabindex -1 solo finché ha il
         fuoco; data-mii-approdo toglie l'anello (CSS). Prima il fuoco e poi lo scroll: dove preventScroll
         non c'è, lo scroll del fuoco viene corretto subito dopo. */
      var via = null;
      if (!el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('data-mii-approdo', '');
        via = function () { el.removeAttribute('tabindex'); el.removeAttribute('data-mii-approdo'); };
        el.addEventListener('blur', via, { once: true });
      }
      try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); }
      if (via && document.activeElement !== el) { el.removeEventListener('blur', via); via(); }
      this.scorriA(this.posizione(el, this.y(), this.baseScroller()) - this.topH, 'instant');
    }

    /* Barra prodotto: compare dopo l'hero (senza hero: appena la sezione arriva sotto la testata),
       sparisce quando la sezione finisce; voce attiva in oro */
    barra(y) {
      if (!this.nav) return;
      var h = this.perTipo.hero, fine = this.radice.top + this.radice.h;
      var dopoHero = h ? y > h.top + h.h - this.vista * .9 : y + this.topH >= this.radice.top - 1;
      var dentro = fine - y > this.topH + this.navH;
      this.nav.classList.toggle('mii-su', dopoHero && dentro);
      /* voce attiva: la scena (o il carosello) che occupa la riga al 40% della vista sotto la testata.
         Posizioni lette dal vivo: le scene dell'altra parte e il carosello cambiano altezza per conto loro. */
      var att = null, riga = this.baseScroller() + this.topH + this.vista * .4, self = this;
      this.voci.forEach(function (v) {
        if (v.a.hidden) return;
        var el = self.bersaglio(v);
        if (!el) return;
        var r = el.getBoundingClientRect();
        if (r.top <= riga && r.bottom > riga) att = v.a;
      });
      if (att === this.vocAtt) return;
      this.vocAtt = att;
      /* voce attiva: oro per chi vede, aria-current per i lettori di schermo */
      this.voci.forEach(function (v) {
        var on = v.a === att;
        v.a.classList.toggle('mii-attiva', on);
        if (on) v.a.setAttribute('aria-current', 'true');
        else v.a.removeAttribute('aria-current');
      });
    }

    /* ---- Osservatori: video che partono vicino allo schermo, preparazione delle scene entro 2 schermate ---- */
    osservatori() {
      this.chiudiOsservatori();
      var self = this;
      if (!('IntersectionObserver' in window)) {
        this.vicini.forEach(function (el) { self.prepara(el); });
        return;
      }
      /* con .page-wrapper la radice deve essere lui, altrimenti il margine non conta (ritaglio dello scroll) */
      var root = this.scroller === window ? null : this.scroller;
      this.ioVideo = new IntersectionObserver(function (voci) {
        voci.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && self.fx && !self.fermo) {
            if (!v.getAttribute('src') && v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
            if (v.getAttribute('src')) gioca(v);
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { root: root, rootMargin: '150px 0px' });
      this.video.forEach(function (v) { self.ioVideo.observe(v); });

      this.ioVicino = new IntersectionObserver(function (voci) {
        voci.forEach(function (e) {
          if (!e.isIntersecting) return;
          self.ioVicino.unobserve(e.target);
          self.prepara(e.target);
        });
      }, { root: root, rootMargin: VICINO });
      this.vicini.forEach(function (el) { if (!el.hasAttribute('data-mii-pronto')) self.ioVicino.observe(el); });
    }

    chiudiOsservatori() {
      if (this.ioVideo) { this.ioVideo.disconnect(); this.ioVideo = null; }
      if (this.ioVicino) { this.ioVicino.disconnect(); this.ioVicino = null; }
    }

    /* Scena entro 2 schermate: immagini senza lazy, anteprime delle clip, fotogrammi del tuffo.
       Gli elementi nascosti (quarta colonna su telefono, righe 6-7 del muro su desktop) restano pigri. */
    prepara(el) {
      el.setAttribute('data-mii-pronto', '');
      tutti('img[loading="lazy"]', el).forEach(function (im) { if (visibile(im)) im.loading = 'eager'; });
      tutti('video[data-poster]', el).forEach(function (v) {
        if (!v.getAttribute('poster') && visibile(v)) v.setAttribute('poster', v.getAttribute('data-poster'));
      });
      if (el.getAttribute('data-scene') === 'tuffo' && this.fx) this.caricaFotogrammi();
    }

    /* ---- Tuffo nella pelle: sequenza di fotogrammi su canvas (tecnica Apple) ---- */
    preparaTuffo(s) {
      var tf = { urls: [], img: [], voluto: 0, disegnato: -1, chiesto: false, annullato: false, canvas: null, ctx: null, poster: null };
      if (s.film) {
        try { tf.urls = JSON.parse(s.film.getAttribute('data-frames') || '[]'); } catch (e) { tf.urls = []; }
        tf.canvas = s.film.querySelector('.mii-tuffo-canvas');
        tf.ctx = tf.canvas && tf.canvas.getContext ? tf.canvas.getContext('2d') : null;
        tf.poster = s.film.querySelector('.mii-tuffo-poster');
      }
      this.tf = tf;
    }

    /* Il primo fotogramma è anche il poster: si carica subito e fa da fotogramma 0 */
    agganciaPoster() {
      var tf = this.tf, im = tf && tf.poster, self = this;
      if (!im) return;
      var usa = function () {
        if (tf.annullato || !im.naturalWidth) return;
        tf.img[0] = im;
        self.ridisegna();
      };
      if (im.complete && im.naturalWidth) usa();
      else im.addEventListener('load', usa, { once: true });
      if (im.loading === 'lazy') im.loading = 'eager';
    }

    /* La coda si ferma se la pagina passa alla versione statica (che non scarica i fotogrammi)
       e riparte dal punto in cui era quando le scene tornano: H.tuffo la richiama a ogni fotogramma. */
    caricaFotogrammi() {
      var tf = this.tf, self = this;
      if (!tf || tf.annullato || !tf.urls.length || !this.fx) return;
      if (tf.chiesto) { if (tf.riprendi) tf.riprendi(); return; }
      tf.chiesto = true;
      var n = tf.urls.length, telefono = window.innerWidth <= PICCOLO;
      var urls = tf.urls.map(function (u) { return telefono ? String(u).replace(/([?&])width=1280(?!\d)/, '$1width=720') : u; });
      /* dal grosso al fine: un fotogramma ogni 16, poi ogni 8, 4, 2, 1 (lo scroll trova presto un vicino) */
      var ordine = [], visto = [];
      for (var passo = 16; passo >= 1; passo = passo >> 1) {
        for (var i = 0; i < n; i += passo) if (!visto[i]) { visto[i] = true; ordine.push(i); }
      }
      var pos = 0, attivi = 0;
      function prossimo() {
        while (!tf.annullato && self.fx && attivi < 6 && pos < ordine.length) {
          var k = ordine[pos++];
          if (tf.img[k] || (k === 0 && tf.poster)) continue;
          carica(k);
        }
      }
      tf.riprendi = prossimo;
      function carica(k) {
        var im = new Image();
        im.decoding = 'async';
        attivi++;
        im.onload = function () { attivi--; if (tf.annullato) return; tf.img[k] = im; self.ridisegna(); prossimo(); };
        im.onerror = function () { attivi--; if (!tf.annullato) prossimo(); };
        im.src = urls[k];
      }
      prossimo();
    }

    /* Disegna il fotogramma k (o il più vicino già carico) con logica object-fit: cover; solo se cambia */
    disegna(k) {
      var tf = this.tf;
      if (!tf || !tf.ctx) return;
      tf.voluto = k;
      var n = tf.urls.length, j = -1;
      for (var d = 0; d < n; d++) {
        if (tf.img[k - d]) { j = k - d; break; }
        if (tf.img[k + d]) { j = k + d; break; }
      }
      if (j < 0 || j === tf.disegnato) return;
      var c = tf.canvas, cw = c.width, ch = c.height, im = tf.img[j];
      if (!cw || !ch || !im.naturalWidth) return;
      var sc = Math.max(cw / im.naturalWidth, ch / im.naturalHeight);
      var w = im.naturalWidth * sc, h = im.naturalHeight * sc;
      tf.ctx.drawImage(im, (cw - w) / 2, (ch - h) / 2, w, h);
      tf.disegnato = j;
    }

    ridisegna() {
      if (this.fx && this.tf) this.disegna(this.tf.voluto);
    }

    /* Canvas grande quanto la scena, devicePixelRatio al massimo 2 */
    dimensionaCanvas() {
      var tf = this.tf;
      if (!tf || !tf.canvas) return;
      var c = tf.canvas, dpr = Math.min(2, window.devicePixelRatio || 1);
      var w = Math.round(c.clientWidth * dpr), h = Math.round(c.clientHeight * dpr);
      if (w && h && (c.width !== w || c.height !== h)) {
        c.width = w;
        c.height = h;
        tf.disegnato = -1;          // il canvas ridimensionato è vuoto
      }
      this.ridisegna();
    }

    /* ---- Clic: pulsante dei video, voci e logo della barra ---- */
    alClick(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      /* Pulsante dei video: ferma e riprende tutti i video della landing (hero, clip, muro), in tutte le parti */
      var b = t.closest('.mii-pausa');
      if (b && this.contains(b)) {
        STATO.fermo = !STATO.fermo;
        tutti('mii-landing', document).forEach(function (el) { if (el.applicaFermo) el.applicaFermo(); });
        return;
      }
      /* Voci della barra: la scena si cerca nel documento; il logo torna all'inizio della landing */
      var a = t.closest('a');
      if (!a || !this.nav || !this.nav.contains(a)) return;
      var dest = null;
      if (a === this.logo) {
        dest = document.getElementById('mii-hero') || document.querySelector('mii-landing');
      } else {
        var v = this.voci.filter(function (x) { return x.a === a; })[0];
        if (!v) return;                          // l'Acquista della barra è un link vero a un'altra pagina
        dest = this.bersaglio(v);
      }
      if (!dest) return;                         // nessuna scena da raggiungere: resta il link normale
      e.preventDefault();
      this.vaiA(dest);
    }

    /* Applica lo stato comune del pulsante dei video a questa istanza */
    applicaFermo() {
      if (!this._montato || this.fermo === STATO.fermo) return;
      this.fermo = STATO.fermo;
      this.classList.toggle('mii-fermo', this.fermo);
      this.etichettePausa();
      if (this.fermo) tutti('video', this).forEach(function (v) { v.pause(); });
      else this.osservatori();                  // le nuove osservazioni fanno ripartire i video in vista
    }

    etichettePausa() {
      var f = this.fermo;
      tutti('.mii-pausa', this).forEach(function (b) {
        var t = b.getAttribute(f ? 'data-riprendi' : 'data-pausa') || '';
        if (b.classList.contains('mii-pausa-icona')) { b.setAttribute('aria-label', t); b.setAttribute('title', t); }
        else b.textContent = t;
      });
    }

    /* ---- Tastiera: il fuoco sull'Acquista della rivelazione mostra il tuffo completo, dove la scheda si vede ---- */
    alFocus(e) {
      if (!this.fx) return;
      var t = e.target, r = t && t.closest ? t.closest('.mii-rivela') : null;
      if (!r || !this.contains(r)) return;
      try { if (!t.matches(':focus-visible')) return; } catch (err) { /* browser senza :focus-visible: si procede */ }
      var i = this.pagine.indexOf(this.perTipo.tuffo);
      if (i < 0) return;
      if (this.corrente === i) this.fermaSequenza();
      this.rendi(i, Infinity);
    }

    baseScroller() {
      return this.scroller === window ? 0 : this.scroller.getBoundingClientRect().top;
    }

    scorriA(top, comportamento) {
      var dove = this.scroller === window ? window : this.scroller;
      try { dove.scrollTo({ top: Math.max(0, top), behavior: comportamento || 'auto' }); }
      catch (err) { dove.scrollTo(0, Math.max(0, top)); }
    }

    /* ---- Editor del tema: un'altra sezione aggiunta, tolta, nascosta, ridisegnata o spostata ----
       La radice di questa parte può restare ferma (la sezione cambiata sta sotto), quindi nessuna misura
       partirebbe da sola: si rimisura, voci della barra comprese, al giro dopo, perché l'unload arriva
       prima che la sezione sparisca. Gli eventi della propria sezione non contano: l'istanza viene smontata. */
    dopoSezioni() {
      var self = this;
      clearTimeout(this._tSezioni);
      this._tSezioni = setTimeout(function () { self._tSezioni = 0; self.misura(); }, 0);
    }

    /* ---- Editor del tema: scegliendo un blocco la pagina va alla sua scena, ferma nel punto dove il blocco si vede ---- */
    alBlocco(e) {
      var el = e.target;
      if (!this.fx || !el || !el.nodeType || !this.contains(el)) return;
      var sEl = el.closest('[data-scene]');
      var s = sEl && this.scene.filter(function (x) { return x.el === sEl; })[0];
      if (!s) return;
      var p = 1, i, n;
      if (s.tipo === 'linea') { n = s.voci.length; i = s.voci.indexOf(el); if (i >= 0) p = n > 1 ? .04 + .92 * i / (n - 1) : 0; }
      else if (s.tipo === 'dettagli') { n = s.voci.length; i = s.voci.indexOf(el); if (i >= 0) p = .03 + .94 * (i + .5) / n; }
      else if (s.tipo === 'passi') { n = s.passi.length; i = s.passi.indexOf(el); if (i >= 0) p = (i + .5) / n; }
      var k = this.pagine.indexOf(s);
      this.fermaSequenza();
      this.corrente = k;
      this.scorriA(this.aggancio(k), 'instant');
      this.rendi(k, p * (TEMPO[s.tipo] || 0));
    }
  }

  window.customElements.define('mii-landing', MiiLanding);
})();
